import LocalDatabase from '../../utils/LocalDatabase'
import Types from '../types'

// Our store plugin
const persistPlugin = store => {
  store.subscribe(async (mutation, state) => {
    if (mutation.type === Types.mutations.SET_USER_TOKEN) {
      await LocalDatabase.set(Types.localdb.USER_TOKEN, state.auth.token)
      await LocalDatabase.set(Types.localdb.EXPIRES_IN, state.auth.expiresIn)
      await LocalDatabase.set(Types.localdb.USER_ROLE, state.auth.authUserRole)
      await LocalDatabase.set(Types.localdb.USER, state.auth.user)
    }
    if (mutation.type === Types.mutations.SET_GCE_USER_TOKEN) {
      await LocalDatabase.set(Types.localdb.GCE_USER_TOKEN, state.auth.gceToken)
      await LocalDatabase.set(Types.localdb.GCE_EXPIRES_IN, state.auth.gceExpiresIn)
      await LocalDatabase.set(Types.localdb.GCE_USER, state.auth.gceUser)
    }
    if (mutation.type === Types.mutations.SET_AUTH_RESET) {
      await LocalDatabase.remove(Types.localdb.USER_TOKEN)
      await LocalDatabase.remove(Types.localdb.EXPIRES_IN)
      await LocalDatabase.remove(Types.localdb.USER_ROLE)
      await LocalDatabase.remove(Types.localdb.USER)
    }
    if (mutation.type === Types.mutations.SET_GCE_AUTH_RESET) {
      await LocalDatabase.remove(Types.localdb.GCE_USER_TOKEN)
      await LocalDatabase.remove(Types.localdb.GCE_EXPIRES_IN)
      await LocalDatabase.remove(Types.localdb.GCE_USER)
    }
  })
}

export default persistPlugin
